import React, { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';

interface FormData {
  name: string;
  phone: string;
  message: string;
}

const InquiryForm: React.FC = () => {
  useEffect(() => {
    emailjs.init("YOUR_USER_ID");
  }, []);

  const [formData, setFormData] = useState<FormData>({
    name: '',
    phone: '',
    message: '',
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await emailjs.send(
        'YOUR_SERVICE_ID',
        'YOUR_TEMPLATE_ID',
        {
          to_email: 'admissionsveterinary@gmail.com',
          from_name: formData.name,
          phone: formData.phone,
          message: formData.message
        }
      );

      setSubmitStatus('success');
      setFormData({
        name: '',
        phone: '',
        message: '',
      });
    } catch (error) {
      console.error('Email error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => {
        setSubmitStatus('idle');
      }, 3000);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {submitStatus === 'success' && (
        <div className="bg-green-100 text-green-700 p-3 rounded-md mb-4">
          Thank you! Your inquiry has been submitted successfully.
        </div>
      )}
      
      {submitStatus === 'error' && (
        <div className="bg-red-100 text-red-700 p-3 rounded-md mb-4">
          There was a problem submitting your inquiry. Please try again.
        </div>
      )}
      
      <div>
        <label htmlFor="name" className="block text-gray-700 font-medium mb-1">
          Full Name*
        </label>
        <input
          type="text"
          id="name"
          name="name"
          required
          value={formData.name}
          onChange={handleChange}
          className="form-input"
          placeholder="Enter your full name"
        />
      </div>
      
      <div>
        <label htmlFor="phone" className="block text-gray-700 font-medium mb-1">
          Phone Number*
        </label>
        <input
          type="tel"
          id="phone"
          name="phone"
          required
          value={formData.phone}
          onChange={handleChange}
          className="form-input"
          placeholder="Enter your phone number"
        />
      </div>
      
      <div>
        <label htmlFor="message" className="block text-gray-700 font-medium mb-1">
          Message*
        </label>
        <textarea
          id="message"
          name="message"
          required
          value={formData.message}
          onChange={handleChange}
          rows={4}
          className="form-input"
          placeholder="How can we help you?"
        ></textarea>
      </div>
      
      <button
        type="submit"
        disabled={isSubmitting}
        className={`btn btn-primary w-full ${isSubmitting ? 'opacity-75 cursor-not-allowed' : ''}`}
      >
        {isSubmitting ? 'Submitting...' : 'Submit Inquiry'}
      </button>
      
      <p className="text-xs text-gray-500 mt-2">
        By submitting this form, you agree to our privacy policy and terms of service.
      </p>
    </form>
  );
};

export default InquiryForm;